import { ScrollView } from "react-native";
import { useJourney } from "../contexts/JourneyContext.js";
import ContentItemsList from "../elements/ContentItemsList.jsx";
import GraphicBackground from "../elements/GraphicBackground.jsx";
import Toolbar from "../elements/Toolbar.js";

export default function ScreenFinale(props) {
  const journeyContext = useJourney();

  const finishedFinale = () => {
    journeyContext.finishedFinale();
  };

  return (
    <GraphicBackground source={journeyContext.serverData?.background_for_finale} >
      <ScrollView style={{paddingTop: 60, flex: 1}} contentContainerStyle={{flexGrow: 1}}>
        <ContentItemsList
          contentItems={journeyContext.finaleItems()}
          completionButtonLabel="Done"
          completionButtonTapped={finishedFinale}
        />
      </ScrollView>

      <Toolbar />
    </GraphicBackground>
  );
}